"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_final_form_1 = require("react-final-form");
const components_1 = require("components");
const config_1 = require("config");
function FilterTransactions({ onSubmit }) {
    const [currentOption, setCurrentOption] = (0, react_1.useState)(config_1.TRANSACTION_FILTERS.CUSTOMER_NAME);
    const formSubmit = () => {
        // Does not need to do anything
        // The form is submitted on input change
    };
    const handleRadioField = (evt) => {
        setCurrentOption(evt.target.value);
    };
    const handleOnInput = (evt) => {
        onSubmit({
            searchField: evt.target.value,
            filterOption: currentOption,
        });
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Form, { initialValues: {
                searchOption: 'customer-name',
            }, onSubmit: formSubmit, render: ({ handleSubmit }) => {
                return ((0, jsx_runtime_1.jsx)("form", { className: "mar-b-20 w100", onSubmit: handleSubmit, noValidate: true, children: (0, jsx_runtime_1.jsxs)("div", { className: "flex", children: [(0, jsx_runtime_1.jsx)(react_final_form_1.Field, { className: "table-search-input", name: "searchName", component: components_1.InputText, type: "search", placeholder: currentOption === config_1.TRANSACTION_FILTERS.CUSTOMER_NAME
                                    ? 'First and Last Name'
                                    : 'Account/Loan Number', label: "Search Field", onInput: handleOnInput, nomargin: 'true' }), (0, jsx_runtime_1.jsx)("fieldset", { className: "no-margin flex align-center", onChange: handleRadioField, children: (0, jsx_runtime_1.jsxs)("div", { className: "input-wrapper flex align-start", children: [(0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "searchOption", label: false, component: components_1.InputRadio, type: "radio", value: config_1.TRANSACTION_FILTERS.CUSTOMER_NAME, radiotext: "Customer Name" }), (0, jsx_runtime_1.jsx)("div", { children: "\u00A0 \u00A0" }), (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "searchOption", label: false, component: components_1.InputRadio, type: "radio", value: config_1.TRANSACTION_FILTERS.ACCOUNT_NUMBER, radiotext: "Account/Loan Number", errhide: true })] }) })] }) }));
            } }) }));
}
exports.default = FilterTransactions;
